import { Spinner } from '@lightspeed/unified-components-helios-theme/react'
import React from 'react'
import { useT } from '@transifex/react'
import { LineItemTab } from '../../../../../types/lineItemTabs'
import { LineItemDisplayDetails } from '../LineItemDisplayDetails'
import { LineItemDisplayFulfilment } from '../fulfilment/LineItemDisplayFulfilment'
import { LineItemTabs } from '../LineItemTabs'
import {
  LineItemExpandedProps,
  useLineItemExpandedModel,
} from './useLineItemExpandedModel'

export const LineItemExpanded = (props: LineItemExpandedProps) => {
  const t = useT()
  const model = useLineItemExpandedModel(props)

  if (props.lineItem.calculating) {
    return (
      <div className="uc-base">
        <div className="flex items-center justify-center py-6 typography-body-sm">
          <Spinner
            customClasses={{
              icon: 'text-go-default',
              content: 'text-neutral-soft',
            }}
          >
            {t('Loading product information')}
          </Spinner>
        </div>
      </div>
    )
  }

  return (
    <div className="uc-base">
      <LineItemTabs
        fulfillmentType={props.lineItem.fulfilmentType}
        lineItemId={props.lineItem.id || props.lineItem.localId}
      />

      {model.currentTab === LineItemTab.DETAIL && (
        <LineItemDisplayDetails
          lineItem={props.lineItem}
          editAllowedForConfirmed={props.editAllowedForConfirmed}
          elementToFocus={props.elementToFocus}
        />
      )}

      {model.currentTab === LineItemTab.FULFILMENT && (
        <div className="sale-fulfilment vd-pb4">
          <LineItemDisplayFulfilment
            lineItem={props.lineItem}
            onSelectFulfilmentType={props.onSelectFulfilmentType ?? (() => {})}
          />
        </div>
      )}
    </div>
  )
}
